import { cn } from "../../../lib/cn";

/**
 * AreaCard — tarjeta seleccionable grande para formularios
 * (selección de área en creación de incidencia).
 *
 * Estado `selected` con borde navy + box-shadow suave.
 *
 * Uso:
 *   <AreaCard
 *     icon={<Monitor size={20} />}
 *     label="Hardware"
 *     area="hardware"
 *     selected={areaSel === 'hardware'}
 *     onClick={() => setAreaSel('hardware')}
 *   />
 *
 * NOTA: las clases bg-area-${area}-bg / text-area-${area}-fg se generan
 * porque AreaChip.jsx las declara como literales completos para las 8
 * áreas (Tailwind las detecta ahí). Si en el futuro se elimina AreaChip,
 * añadir esas clases al safelist de tailwind.config.
 */

export function AreaCard({ icon, label, area, selected, onClick, className }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex flex-col items-center justify-center gap-1.5",
        "w-[100px] h-[80px] rounded-lg border transition-all",
        selected
          ? "border-primary bg-primary/5 shadow-[0_0_0_3px_rgba(0,60,102,0.1)]"
          : "border-border bg-card hover:border-slate-300",
        className,
      )}
    >
      <div className={cn(
        "w-8 h-8 rounded-md flex items-center justify-center",
        `bg-area-${area}-bg text-area-${area}-fg`,
      )}>
        {icon}
      </div>
      <div className="text-xs font-medium text-slate-700">{label}</div>
    </button>
  );
}
